<template>
  <v-dialog v-model="isTaskViewerOpen" max-width="600px">
    <TaskRunnerCard @close="isTaskViewerOpen = false" />
  </v-dialog>
</template>

<script lang="ts" setup>
  import { ref, watch } from 'vue';
  import TaskRunnerCard from '@/components/TaskRunnerCard.vue';
  import { useTaskStore } from '@/store/taskStore';

  const isTaskViewerOpen = ref(false);
  const taskStore = useTaskStore();

  // Watch for changes in the task completion status
  watch(
    () => taskStore.hasAllTasksCompleted,
    (newVal) => {
      if (!newVal) {
        isTaskViewerOpen.value = true;
      }
    }
  );
</script>
